"use strict";

/**
  * @reach/auto-id v0.18.0
  *
  * Copyright (c) 2018-2022, React Training LLC
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE.md file in the root directory of this source tree.
  *
  * @license MIT
  */

// src/reach-auto-id.ts
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import * as React from "react";
import { useIsomorphicLayoutEffect as useLayoutEffect } from "@reach/utils";
var serverHandoffComplete = false;
var id = 0;
function genId() {
  return ++id;
}
var maybeReactUseId = React["useId".toString()];
function useId(providedId) {
  var _ref;
  if (maybeReactUseId !== void 0) {
    var generatedId = maybeReactUseId();
    return providedId !== null && providedId !== void 0 ? providedId : generatedId;
  }
  var initialId = providedId !== null && providedId !== void 0 ? providedId : serverHandoffComplete ? genId() : null;
  var _React$useState = React.useState(initialId),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    id2 = _React$useState2[0],
    setId = _React$useState2[1];
  useLayoutEffect(function () {
    if (id2 === null) {
      setId(genId());
    }
  }, []);
  React.useEffect(function () {
    if (serverHandoffComplete === false) {
      serverHandoffComplete = true;
    }
  }, []);
  return (_ref = providedId !== null && providedId !== void 0 ? providedId : id2) !== null && _ref !== void 0 ? _ref : void 0;
}
export { useId };